import * as React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Images/SBLCentral-Logo-Resize.jpg";
import questionHelpLogo from "../../Assets/Images/questionmark-icon.png";
import { DropdownButton, ButtonToolbar } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";

import "./headerStyles.css";
import { Login } from "../../Containers/Login/login";
import { ModalConsumer } from "../../Containers/Login/loginContext";
import ModalRoot from "../../Containers/Login/loginRoot";

class Header extends React.Component {
  constructor(props) {
    super(props);

    var loggedInUser = {
      errorText: "",
      isAuthenticated: false,
      firstName: "",
      lastName: "",
      sblId: "",
      isAdminUser: false
    };

    this.state = {
      loggedInUser: loggedInUser
    }
  }

  async componentDidMount() {
    if (sessionStorage.getItem("loggedInUser")) {
      let loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser"));

      this.setState({
        loggedInUser: loggedInUser
      });
    }
  }

  onLoginClick = () => {
    this.showModal();

    if (sessionStorage.getItem("loggedInUser")) {
      this.setState({
        loggedInUser: JSON.parse(sessionStorage.getItem("loggedInUser"))
      });

      console.log('Updated user: ', this.state.loggedInUser);
    }
  };

  onLogoutClick = () => {
    this.setState(prevState => ({
      loggedInUser: {
        ...prevState.loggedInUser,
        errorText: "",
        isAuthenticated: false,
        isAdminUser: false,
        firstName: "",
        lastName: "",
        sblId: ""
      }
    }), () => {
      sessionStorage.setItem("loggedInUser", JSON.stringify(this.state.loggedInUser));
      //Redirect to home page
      window.location.assign("/home");
    });
  };

  returnSignIn = () => {
    return <div>{this.returnSignInBlock(this.state.loggedInUser)}</div>;
  };

  calculateUserName = (user) => {
    if (user.firstName && user.lastName) {
      return user.firstName + " " + user.lastName;
    }
    else if ( user.firstName ) {
      return user.firstName;
    }
    else if ( user.lastName) {
      return user.lastName;
    }

    return "Member";
  }

  returnSignInBlock(loggedInUser) {
    if (loggedInUser && loggedInUser.isAuthenticated === true) {
      return (
        <div className="LogInNameContainer nav navbar-right">
          <ButtonToolbar>
            <DropdownButton
              title={<>{this.calculateUserName(loggedInUser)} <span className="caret"></span></>}
              id="dropdown-size-medium"
              className="LoginUserText"
            >
              {this.getNotificationsMenu(loggedInUser)}
              {/* October 2024 - Harsha Hammika - Journal notifications have been discontinued. Therefore, this [file or function] is no longer utilized.  */}
              {/* {this.getJournalNotificationsMenu(loggedInUser)} */}
              {this.getAdminMenu(loggedInUser)}
              <Dropdown.Item eventKey="allFilter" onClick={this.onLogoutClick}>
                Sign Out
              </Dropdown.Item>
            </DropdownButton>
          </ButtonToolbar>
        </div>
      );
    } else {
      return (
        <div className="SignInButtonContainer nav navbar-right">
          <ModalRoot />
          <ModalConsumer>
            {({ showModal }) => (
              <Fragment>
                <button
                  id="sign-in-button"
                  className="SignInButton"
                  onClick={() => showModal(Login)}
                >
                  Sign In
                </button>
              </Fragment>
            )}
          </ModalConsumer>
        </div>
      );
    }
  }

  getAdminMenu(loggedInUser) {
    if(loggedInUser.isAdminUser) {
      return (
        <Dropdown.Item eventKey="admin" onClick={this.onAdminClick} >
          SBLC Admin
        </Dropdown.Item>
      );
    }
  }

  getNotificationsMenu(loggedInUser) {
    return (
      <Fragment>
        <Dropdown.Item eventKey="notifications" onClick={(e) => window.location = '/home/notifications'} >
          Manage Book Notifications
        </Dropdown.Item>
      </Fragment>
    )
  }

  getJournalNotificationsMenu(loggedInUser) {
    return (
      <Dropdown.Item eventKey="journalnotifications" onClick={(e) => window.location = '/home/journalNotifications'}>
        Manage Journal Notifications
      </Dropdown.Item>
    )
  }

  onAdminClick = () => {
    window.location = '/admin';
  }

  render() {
    return (
      <nav id="header" className="Header navbar navbar-default">
        <div className="logoContainer navbar-header navbar-left">
          <Link to={`/`} replace className="navbar-brand">
            <img className="logo-image" src={logo} alt="sbl logo" />
          </Link>
        </div>
        
        <div id="helpaAndLoginContainer">
          <div className="HelpLinkContainer nav navbar-right">
            <Link to={`/help`} className="HelpImage">
              <img
                className="logo-image"
                src={questionHelpLogo}
                alt="Help"
                title="Help"
              />
            </Link>
          </div>

          {this.returnSignIn(this.state.loggedInUser)}
        </div>
      </nav>
    );
  }
}

export { Header };
